import {trigger, animate, state, style, group, query, transition} from '@angular/animations';

export const routerTransition = trigger('routerTransition', [
  transition('* <=> *', [
    query(':enter, :leave', [style({position: 'fixed', width: 'calc(100% - 680px)', padding: '0 10px'})], {optional: true}),
    group([
      query(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('0.5s ease-in', style({ transform: 'translateX(0%)' }))
      ], { optional: true }),
      query(':leave', [
        style({ transform: 'translateX(0%)' }),
        animate('0.5s ease-in', style({ transform: 'translateX(-100%)' }))
      ], { optional: true }),
    ])
  ])
])

export const slideInOut = trigger('slideInOut', [
    state('*', 
        style({
            position: 'fixed',
            width: '100%'
        })
    ),
    transition(':enter', [
        style({
            transform: 'translate(100%)'
        }),
        animate('0.5s ease',
            style({
                transform: 'translateX(0%)'
            })
        )
    ]),
    transition(':leave', [
        style({
            transform: 'translate(0%)'
        }),
        animate('0.5s ease',
            style({
                transform: 'translateX(100%)'
            })
        )
    ])
])


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/router.animations.ts